import { combineReducers } from "redux";

import adminReducer from "./admin/reducer";
import bannerReducer from "./banner/reducer";
import broadcastBannerReducer from "./broadcastBanner/reducer";
import coinPlanReducer from "./coinPlan/reducer";
import vipPlanReducer from "./vipPlan/reducer";
import giftCategoryReducer from "./giftCategory/reducer";
import spinnerReducer from "./spinner/reducer";
import giftReducer from "./gift/reducer";
import songReducer from "./song/reducer";
import hashtagReducer from "./hashtag/reducer";
import levelReducer from "./level/reducer";
import userReducer from "./user/reducer";
import postReducer from "./post/reducer";
import videoReducer from "./video/reducer";
import followerReducer from "./follower/reducer";
import settingReducer from "./setting/reducer";
import advertisementReducer from "./advertisement/reducer";
import complainReducer from "./complain/reducer";
import redeemReducer from "./redeem/reducer";
import dashboardReducer from "./dashboard/reducer";
import reportedUserReducer from "./reportedUser/reducer";
import stickerReducer from "./sticker/reducer";
import themeReducer from "./Theme/theme.reducer";
import fakeCommentReducer from "./fakeComment/reducer";
import { gameHistoryReducer } from "./GameHistory/reducer";
import { admissionSVGAReducer } from "./AdmissionCar/reducer";
import { avatarFrameReducer } from "./AvatarFrame/reducer";
import gameReducer from "./game/reducer";
import requestReducer from "./profileVerification/reducer";
import { coinSellerReducer } from "./coinSeller/reducer";
import agencyReducer from "./agency/reducer";
import agencyRedeemReducer from "./agencyRedeem/reducer";
import commissionReducer from "./commission/reducer";
import myRedeemReducer from "./myRedeem/reducer";
import hostRequestReducer from "./hostRequest/reducer";
import reactionReducer from "./reaction/reducer";
import tagReduer from "./tag/reducer";
import hostReducer from "./host/reducer";

export default combineReducers({
  admin: adminReducer,
  user: userReducer,
  post: postReducer,
  banner: bannerReducer,
  broadcastBanner: broadcastBannerReducer,
  song: songReducer,
  gift: giftReducer,
  game: gameReducer,
  video: videoReducer,
  level: levelReducer,
  sticker: stickerReducer,
  complain: complainReducer,
  gameHistory: gameHistoryReducer,
  redeem: redeemReducer,
  report: reportedUserReducer,
  dashboard: dashboardReducer,
  hashtag: hashtagReducer,
  followersFollowing: followerReducer,
  giftCategory: giftCategoryReducer,
  vipPlan: vipPlanReducer,
  coinPlan: coinPlanReducer,
  setting: settingReducer,
  advertisement: advertisementReducer,
  spinner: spinnerReducer,
  Comment: fakeCommentReducer,
  theme: themeReducer,
  admissionSVGA: admissionSVGAReducer,
  avatarFrame: avatarFrameReducer,
  coinSeller: coinSellerReducer,
  request: requestReducer,
  agency: agencyReducer,
  agencyRedeem: agencyRedeemReducer,
  commission: commissionReducer,
  myRedeem: myRedeemReducer,
  hostRequest: hostRequestReducer,
  reaction: reactionReducer,
  tag : tagReduer,
  host : hostReducer,
});
